export { ChevronDoubleRight as default } from './ChevronDoubleRight';
